export const docSiteUrl = 'https://fluentsite.z22.web.core.windows.net';
export const quickStartUrl = `${docSiteUrl}/quick-start`;
export const repoURL = 'https://github.com/microsoft/fluentui';
